import { Navigate, useLocation } from 'react-router-dom';

/**
 * /CallerLogin and /ClientLogin (DUP-7): the old sign-in addresses, kept for
 * bookmarks and external links. A router redirect to /Login that keeps the
 * query (?next=…), instead of the two pages that rendered nothing, reloaded
 * the app and asked /auth/me three times.
 */
export function LegacyLoginRedirect() {
  const { search, hash } = useLocation();
  return <Navigate to={`/Login${search}${hash}`} replace />;
}
